import { keyframes, styled } from "styled-components";
import { DashboardTitle } from "./DashboardTitle";
import { ParticlesContainer } from "../Particles";
import { useEffect, useRef, useState } from "react";
import { Menu } from "./Menu";

export const Intro = keyframes`
    0%{
        opacity: 0;
    }
    30%{
        opacity: 0;
    }
    50%{
        opacity: 0.2;
    }
    100%{
        opacity: 1;
    }
`;

const TMContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 20vw;
    position: relative;
    box-shadow: 10px 0px 15px -4px rgba(0, 0, 0, 0.75);
    -webkit-box-shadow: 10px 0px 15px -4px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 10px 0px 15px -4px rgba(0, 0, 0, 0.75);
    background: #000000;
    animation: ${Intro} 1s ease-in;
    animation-fill-mode: forwards;
    @media screen and (max-width: ${(props) => props.theme.breakpoint}px) {
        width: 100vw;
        display: none;
    }
`;

export const TitleAndMenu: React.FC = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        containerRef.current
            ? setWidth(containerRef.current?.offsetWidth)
            : setWidth(0);
    }, [containerRef]);

    return (
        <TMContainer ref={containerRef}>
            <ParticlesContainer />
            <DashboardTitle parentWidth={width} />
            <Menu parentWidth={width} />
        </TMContainer>
    );
};
